// RouteChecker.js
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { message } from "antd";
import { SendPostRequest } from "../ApiRequest";
import { MDBContainer } from "mdb-react-ui-kit";

const RouteChecker = ({ children }) => {
  const [valid, setValid] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkToken = async () => {
      const response = await SendPostRequest("api/umrah/dashboard");

      if (response?.message === "Token expired") {
        localStorage.removeItem("token");
        localStorage.removeItem("RememberMe");
        message.error("Token expired. Please log in again.");
        setValid(false);
      } else {
        setValid(true);
      }
    };

    checkToken();
  }, []);

  if (valid === null) {
    return (
      <>
        <>
          <style>
            {`
          .custom-placeholder::placeholder {
            color: #FFFFFF; 
            
            
          }
        `}
          </style>
          <div className="overflow-hidden">
            <div className="background-image-LogIn-logo">
              <MDBContainer breakpoint="sm m-4">
                <div className="main-wrapper">
                  <div>
                    <div
                      className="navebar"
                      style={{
                        background: "",
                        width: "100%",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        className="logo mb-3"
                        src={window.logo}
                        alt="logo"
                        style={{ width: "300px" }}
                      />
                    </div>
                  </div>
                </div>
              </MDBContainer>
            </div>
          </div>
        </>
      </>
    );
  }

  if (!valid) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RouteChecker;
